export const OPEN_STREET_MAP_DATA_PROVIDER = {
  label: 'Open Street Map',
  value: 'OPEN_STREET_MAP',
} as const;
